module.exports = __webpack_public_path__ + "static/media/solar-system.e1fb248b.svg";